import {CatalogConfig} from '../types'

// Geo catalogs — Countries (small, ordered) and Cities (large, alphabetical only).
// Countries backs the country dropdown across the profile; ~250 rows so it stays client-side and
// supports reorder + is_active. Cities has ~30k rows so it uses server-side search/pagination and
// disables reorder — display order is always alphabetical. Both catalogs cover UAT-005 "Limited
// options in city/country list": admins can activate/deactivate rows and add missing entries
// without a deploy.

export const countriesConfig: CatalogConfig = {
  slug: 'countries',
  endpoint: '/catalog/admin/countries/',
  titleId: 'CATALOG.COUNTRIES.TITLE',
  singularId: 'CATALOG.COUNTRIES.SINGULAR',
  primaryField: 'name',
  writable: true,
  reorderable: true,
  softDelete: {field: 'isActive', activeValue: true},
  serverSide: {
    searchParam: 'search',
    orderingParam: 'ordering',
    statusParam: 'isActive',
    sortableFields: ['order', 'name', 'code'],
    defaultOrdering: 'order',
  },
  fields: [
    {name: 'order', labelId: 'CATALOG.FIELD.ORDER', type: 'text', showInTable: true},
    {
      name: 'name',
      labelId: 'CATALOG.FIELD.NAME',
      type: 'text',
      showInTable: true,
      searchable: true,
      required: true,
      maxLength: 255,
    },
    {
      name: 'code',
      labelId: 'CATALOG.FIELD.COUNTRY_CODE',
      type: 'text',
      showInTable: true,
      searchable: true,
      required: true,
      maxLength: 2,
    },
  ],
}

export const citiesConfig: CatalogConfig = {
  slug: 'cities',
  endpoint: '/catalog/admin/cities/',
  titleId: 'CATALOG.CITIES.TITLE',
  singularId: 'CATALOG.CITIES.SINGULAR',
  primaryField: 'name',
  writable: true,
  reorderable: false,
  softDelete: {field: 'isActive', activeValue: true},
  serverSide: {
    searchParam: 'search',
    orderingParam: 'ordering',
    statusParam: 'isActive',
    sortableFields: ['name', 'country'],
    defaultOrdering: 'name',
  },
  fields: [
    {
      name: 'name',
      labelId: 'CATALOG.FIELD.NAME',
      type: 'text',
      showInTable: true,
      searchable: true,
      required: true,
      maxLength: 255,
    },
    {
      name: 'country',
      labelId: 'CATALOG.FIELD.COUNTRY',
      type: 'text',
      showInTable: true,
      searchable: true,
      required: true,
      maxLength: 255,
    },
    {
      name: 'subcountry',
      labelId: 'CATALOG.FIELD.SUBCOUNTRY',
      type: 'text',
      showInTable: false,
      searchable: true,
      required: false,
      maxLength: 255,
    },
  ],
}

export const geoCatalogConfigs: CatalogConfig[] = [countriesConfig, citiesConfig]
